<template>
  <!-- 调研 -->
  <el-container class="research">
    <el-aside width="200px" v-show="clickStatus">
      <div
        class="head"
        @click="setchoosName({ phase: null, name: null, module: null })"
      >
        <i class="el-icon-s-management"></i>里程碑
      </div>
      <el-menu
        :default-openeds="defalut"
        :class="{ ty: $route.query.autoid == '0' }"
      >
        <el-submenu v-for="(e, i) in data" :key="i + ''" :index="i + ''">
          <!-- <template slot="title">
            <div
              class="or"
              @click="
                setchoosName({ phase: e.label, name: null, module: null })
              "
            >
              <span>
                <i class="el-icon-caret-bottom ico1"></i>
                <span>
                  <i class="el-icon-folder  ico2"></i>{{ e.label }}</span
                ></span
              >

              <span class="ps">{{ e.ps }}</span>
            </div>
          </template> -->
          <el-submenu
            v-for="(item, ii) in e.children"
            :key="i + '-' + ii + ''"
            :index="i + '-' + ii + ''"
          >
            <template slot="title">
              <div
                class="or"
                @click="
                  setchoosName({
                    phase: e.label,
                    name: item.label,
                    module: null
                  })
                "
              >
                <span>
                  <i class="el-icon-caret-bottom ico1"></i>
                  <span>
                    <i class="el-icon-folder  ico2"></i>{{ item.label }}</span
                  ></span
                >
              </div>
            </template>
            <el-menu-item-group>
              <el-menu-item
                v-for="(obj, iii) in item.children"
                :key="i + '-' + ii + '-' + iii"
                :index="i + '-' + ii + '-' + iii"
                @click="
                  setchoosName({
                    phase: e.label,
                    name: item.label,
                    module: obj
                  })
                "
              >
                <i
                  class="el-icon-tickets"
                  style="color:  rgba(0, 127, 245, 1);"
                ></i
                >{{ obj }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-submenu>
      </el-menu>
      <div class="footer" v-if="this.$route.query.autoid != '0'">
        <el-button type="primary" class="bg" @click="addBG()">
          项目变更
        </el-button>
        <el-button size="instructionsall" @click="showTable()">
          <i class="el-icon-document"></i>
        </el-button>
      </div>
    </el-aside>
    <div class="toggle-middle-col">
      <div
        class="tree-toggle"
        :style="clickStatus ? 'background:#e8edf7' : 'background:none'"
      >
        <span
          class="toggle-icon"
          :title="clickStatus ? '收起' : '展开'"
          @click="treeClickFun"
        >
          <!-- el-icon-arrow-right #e8edf7-->
          <i
            :class="clickStatus ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
          ></i>
        </span>
      </div>
    </div>
    <el-main>
      <div class="toolbar">
        <div class="tl">
          <el-button type="primary" size="mini" class="bg" @click="add()" v-if="$route.query.autoid != '0' || userInfo.rootty">
            <i class="el-icon-plus"></i> 新增
          </el-button>
          <el-input
            v-model="input"
            placeholder="请输入关键字"
            size="instructionsall"
            class="i150"
          />
          <el-button size="mini" type="primary" @click="getTable">
            搜索
          </el-button>
          <el-button
            size="mini"
            type="warning"
            @click="copy"
            v-if="$route.query.autoid != '0'"
          >
            生成任务明细
          </el-button>
          <el-button
            size="mini"
            type="warning"
            @click="copyty"
            v-if="$route.query.autoid != '0' && ini.length == 0"
          >
            导入通用任务
          </el-button>
          <el-button size="mini" type="warning" @click="Excel" v-if="$route.query.autoid != '0' || userInfo.rootty">
            导入Excel
          </el-button>
          <el-button size="mini" @click="downloadd">
            <i class="el-icon-download"></i>
            下载模板
          </el-button>
        </div>
        <div class="tr">
          <el-button size="mini">
            <i class="el-icon-download"></i>
            下载报表
          </el-button>
          <span :class="{ isactive: mode == 1 }" @click="mode = 1"
            ><i class="el-icon-bank-card"></i>列表</span
          >
          <!-- |
          <span :class="{ isactive: mode == 2 }" @click="mode = 2"
            ><i class="el-icon-set-up"></i>表单</span
          > -->
        </div>
      </div>

      <div
        class="tablemode"
        :class="{ ty: this.$route.query.autoid == '0' }"
        v-if="mode == 1"
      >
        <el-table
          ref="table"
          border
          stripe
          v-loading="tableload"
          highlight-current-row
          :data="tbDate"
          :span-method="objectSpanMethod"
          tooltip-effect="dark"
          header-row-class-name="table_header"
          :header-row-style="{ 'text-align': 'center' }"
          @selection-change="handleSelectionChange"
          :cell-style="{ textAlign: 'center' }"
          style="width: 100%"
          height="100%"
          @mouseleave.native="toolsHideFn()"
          @current-change="handleCurrentRow"
          @row-dblclick="handRowdbClick"
        >
          <el-table-column
            v-for="(item, i) in th"
            :key="i"
            :label="item.chnname"
            :width="item.width"
            align="center"
            show-overflow-tooltip
            :column-key="item.fieldname"
            :filters="filters[item.fieldname]"
            :filter-method="filterHandler"
          >
            <template slot-scope="scope">
              <template
                v-if="
                  scope.row.isEdit &&
                    !(scope.row.ischeck1 || scope.row.ischeck2) &&
                    false
                "
              >
                <el-switch
                  v-if="item.switch"
                  v-model="scope.row[item.fieldname]"
                  active-color="#1890FF"
                  inactive-color="#999999"
                ></el-switch>
                <el-select
                  clearable
                  v-else-if="item.select"
                  v-model="scope.row[item.fieldname]"
                  :filterable="item.canedit"
                  :allow-create="item.canedit"
                  :default-first-option="item.canedit"
                  placeholder="请选择状态"
                >
                  <el-option
                    v-for="item in tboptions[item.fieldname]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input
                  v-else-if="item.number"
                  v-model="scope.row[item.fieldname]"
                  oninput="value=value.replace(/\D/g,'')"
                />
                <el-date-picker
                  v-else-if="item.datetime"
                  type="date"
                  placeholder="选择日期"
                  v-model="scope.row[item.fieldname]"
                  style="width: 100%;"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
                <span v-else-if="item.readonly">{{
                  item.switch
                    ? scope.row[item.fieldname]
                      ? '是'
                      : '否'
                    : scope.row[item.fieldname]
                }}</span>
                <el-input
                  v-else
                  v-model="scope.row[item.fieldname]"
                  :type="item.memo ? 'textarea' : ''"
                  :autosize="{ minRows: 4 }"
                />
              </template>

              <span v-else>{{
                item.switch
                  ? scope.row[item.fieldname]
                    ? '是'
                    : '否'
                  : scope.row[item.fieldname]
              }}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            :label="'操作'"
            width="80"
            fixed="right"
            class-name="operateColumn"
            v-if="$route.query.autoid != '0' || userInfo.rootty"
          >
            <template slot-scope="scope">
              <span
                v-for="(el, index) in btns"
                :key="index"
                v-show="
                  (scope.row[el.checkfield] == el.checkvalue &&
                    $route.query.autoid != '0') ||
                    ($route.query.autoid == '0' &&
                      ['del', 'edit', 'editdetial'].indexOf(el.actionName) >
                        -1 &&
                      ((['zjl', 'zjlfs'].indexOf(el.actionName) > -1 &&
                        userInfo.director) ||
                        (['jl', 'jlfs'].indexOf(el.actionName) > -1 &&
                          scope.row.Service_Manager == userInfo.name) ||
                        el.actionName.indexOf('js') == -1))
                "
              >
                <span v-if="index > 0" class="divid">|</span>
                <span
                  class="table_operate"
                  :title="el.label"
                  @click="actionClick(el, scope.row)"
                >
                  <svg-icon :icon-class="el.icon" /> </span
              ></span>
            </template>
          </el-table-column>
        </el-table>
        <div class="footer">
          <el-pagination
            background
            align="right"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100, 200, 300, 400, 500]"
            :page-size="pageSize"
            layout="prev, pager, next, sizes,jumper,total"
            :total="tableData.length"
          ></el-pagination>
          <!-- <el-button type="primary" @click="tableSave('2', null)"
            >保存</el-button
          > -->
        </div>
      </div>
      <el-container class="formmode" v-if="mode == 2">
        <el-aside width="200px">
          <div
            class="prolist"
            :class="{
              isactive: prolistchoos.autoid == e.autoid
            }"
            v-for="(e, i) in tableData"
            :key="i"
            @click="handClickProList(e)"
          >
            <div class="ico"></div>
            {{ e.taskdetail }}
          </div>
        </el-aside>
        <el-main>
          <div class="formhead">
            <div class="title">
              <span>任务信息</span>
              - {{ prolistchoos.name || '' }}
            </div>
            <div class="btn">
              <el-button
                v-for="(el, index) in btns"
                :key="index"
                :style="[
                  { background: el.ys },
                  { color: '#ffffff' },
                  { 'border-radius': '4px' },
                  { 'border-color': el.ys }
                ]"
                size="instructionsall"
                @click="actionClick(el, prolistchoos)"
                v-show="
                  prolistchoos[el.checkfield] == el.checkvalue &&
                    ((el.actionName.indexOf('zjl') > -1 && userInfo.director) ||
                      (el.actionName.indexOf('zjl') == -1 &&
                        prolistchoos.Service_Manager == userInfo.name))
                "
                >{{ el.label }}</el-button
              >
            </div>
          </div>
          <div class="form">
            <researchForm ref="form" :tboptions="tboptions" />
          </div>
          <div class="foot">
            <el-button
              type="primary"
              @click="formSave()"
              :disabled="prolistchoos.ischeck1 || prolistchoos.ischeck2"
              >保存</el-button
            >
          </div>
        </el-main>
      </el-container>
    </el-main>
    <!-- 调研 -->
    <veaDialog
      :title="title"
      class="reForm"
      :show.sync="showre"
      :before-close="closeDialogre"
      :width="form.autoid && title != '修改项目调研' ? '300px' : ''"
    >
      <el-form ref="form" :model="form1" label-width="80px">
        <template v-if="form.autoid && title != '修改项目调研'">
          <!-- <el-form-item label="所属阶段">
            <el-select
              clearable
              v-model="form.phase"
              placeholder="请选择所属阶段"
            >
              <el-option
                v-for="item in tboptions.phase"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="模块分类" :required="true">
            <el-select
              clearable
              v-model="form.name"
              placeholder="请选择模块分类"
            >
              <el-option
                v-for="item in tboptions.name"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="模块" :required="true">
            <el-select clearable v-model="form.module" filterable placeholder="请选择模块">
              <el-option
                v-for="item in tboptions.module"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-row v-else>
          <!-- <el-col :span="6">
            <el-form-item label="所属阶段">
              <el-select
                clearable
                v-model="form.phase"
                placeholder="请选择所属阶段"
              >
                <el-option
                  v-for="item in tboptions.phase"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item label="模块分类" :required="true">
              <el-select
                clearable
                v-model="form.name"
                placeholder="请选择模块分类"
              >
                <el-option
                  v-for="item in tboptions.name"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <researchForm
        ref="researchForm"
        :tboptions="tboptions"
        v-show="!form.autoid || title == '修改项目调研'"
      />
    </veaDialog>
    <!-- 变更记录 -->
    <veaDialog
      :title="title"
      class="reCHForm"
      :show.sync="show"
      :before-close="closeDialog"
    >
      <researchCHForm ref="researchCHForm" :tboptions="tboptions" />
      <div style="padding:0 20px;">
        <el-upload
          action
          class="upload-demo"
          ref="upload"
          :file-list="fileList"
          :on-change="handleChange"
          :on-remove="handleRemove"
          :before-remove="removeBefore"
          :auto-upload="false"
        >
          <el-button slot="trigger" size="small" type="primary"
            >变更文档签字上传</el-button
          >
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过500kb
          </div>
        </el-upload>
      </div>
    </veaDialog>
    <dybgTable ref="dybgTable" :tboptions="tboptions" />
    <filelist
      ref="filelist"
      :ty="0"
      :choos="{ name: '项目调研' }"
      :pautoid="tablerow ? tablerow.autoid : 0"
    />
    <TableImport
      ref="TableImport"
      @tableSave="tableSave"
      :mautoid="autoid"
      :type="'1'"
    />
  </el-container>
</template>

<script>
import researchForm from '@components/researchForm.vue'
import researchCHForm from '@components/researchCHForm.vue'
import dybgTable from '@components/dybgTable.vue'
import { createGguid } from '@/assets/js/pubMethods'
import filelist from '@components/filelist.vue'
import TableImport from '@components/tableImport'
import {
  Edit_tpr_xm_dy_change,
  GetFZRlist,
  Query_tpr_xm_dy,
  Edit_tpr_xm_dy,
  check_tpr_xm_dy,
  upLoadCustomFile,
  Copy_tpr_xm_dy,
  Copy_tpr_xm_dy_ty,
  Query_tsys_dicvalue,
  BirthEdit_tpr_xm_dy
} from '@api/api.js'
export default {
  components: {
    researchForm,
    researchCHForm,
    dybgTable,
    filelist,
    TableImport
  },
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.userInfo) || {},
      toolShow: false, // 是否显示工具
      toolExpend: true, // 是否展开工具
      toolStyle: {}, // 工具样式（位置）
      color: [
        '#409eff',
        '#67c23a',
        '#e6a23c',
        '#f56c6c',
        '#1B6AAA',
        '#6FB3E0',
        '#629B58',
        '#E59729',
        '#D15B47',
        '#D6487E',
        '#7461AA',
        '#FEE188'
      ],
      toolsBtn: [
        {
          label: '总监审核',
          actionName: 'zjl',
          checkfield: 'ischeck2',
          icon: 'img100068',
          checkvalue: false
        },
        {
          label: '经理审核',
          actionName: 'jl',
          checkfield: 'ischeck1',
          icon: 'img100068',
          checkvalue: false
        },

        {
          label: '总监返审',
          actionName: 'zjlfs',
          checkfield: 'ischeck2',
          icon: 'imgChanges3',
          checkvalue: true
        },

        {
          label: '经理返审',
          actionName: 'jlfs',
          checkfield: 'ischeck1',
          icon: 'imgChanges3',
          checkvalue: true
        },
        {
          label: '删除',
          actionName: 'del',
          checkfield: 'isactive',
          icon: 'advancedQueryDelete',
          checkvalue: true
        },
        {
          label: '调整分类',
          actionName: 'edit',
          checkfield: 'isactive',
          icon: 'postSystem',
          checkvalue: true
        },
        {
          label: '修改',
          actionName: 'editdetial',
          checkfield: 'isactive',
          icon: 'advancedQueryEdit',
          checkvalue: true
        },
        {
          label: '附件',
          actionName: 'file',
          checkfield: 'isactive',
          icon: 'img100059',
          checkvalue: true
        }
      ],
      tablerow: {},
      tableChange: true,
      mode: 1,
      defaultProps: [],
      defalut: [],
      data: [], // 左边阶段-任务菜单
      tboptions: {
        module: [],
        type: [],
        fzr: [],
        zt: [],
        phase: [],
        name: []
      }, // 通用下拉选项
      input: '',
      value: '',
      currentPage: 1,
      pageSize: 10,
      th: [
        // {
        //   chnname: '所属阶段',
        //   fieldname: 'phase',
        //   width: '100',
        //   select: true,
        //   canedit: true
        // },
        // {
        //   chnname: '模块分类',
        //   fieldname: 'name',
        //   width: '100',
        //   readonly: true
        // },
        {
          chnname: '所属模块',
          fieldname: 'module',
          width: '100',
          readonly: true
        },
        {
          chnname: '任务序号',
          fieldname: 'sqnum',
          width: '80'
        },

        {
          chnname: '类型',
          fieldname: 'type',
          width: '150',
          select: true
        },
        {
          chnname: '任务明细',
          fieldname: 'taskdetail',
          width: '200',
          memo: true
        },
        {
          chnname: '任务说明',
          fieldname: 'instructions',
          width: '200',
          memo: true
        },
        {
          chnname: '负责人',
          fieldname: 'fzr',
          width: '100',
          select: true
        },
        {
          chnname: '是否调研',
          fieldname: 'dy',
          width: '100',
          switch: true
        }
      ],
      ini: [], // 原始的项目调研数据
      tableData: [], //筛选后显示的数据
      tableload: false,
      proptype: '',
      prolistchoos: {},
      form: {
        autoid: 0,
        module: '组织',
        taskdetail: '明细1',
        type: '标准',
        fzr: '张三',
        instructions: '说明1',
        dy: true,
        isEdit: false,
        phase: '',
        name: ''
      },
      show: false,
      showre: false,
      title: '',
      form1: {},
      choosName: { phase: '', name: '' },
      dialogImageUrl: '',
      dialogVisible: false,
      fileList: [],
      clickStatus: true,
      name: this.$route.query.name,
      autoid: this.$route.query.autoid
    }
  },
  created() {
    this._GetFZRlist()
    this._Query_tpr_xm_dy()
    this._Query_tsys_dicvalue()
  },
  //监听路由变化
  watch: {
    '$route.query': {
      handler(newVal, oldVal) {
        //判断newVal有没有值监听路由变化
        this.name = newVal.name
        this.autoid = newVal.autoid
        this._Query_tpr_xm_dy()
      },
      deep: true
    }
  },
  computed: {
    btns() {
      return this.getColor(this.toolsBtn)
    },
    spanArr() {
      let r = [[], []],
        arr = [],
        pos = 0
      arr = this.tableData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      )

      this.tableData
        .map(e => {
          return e.module
        })
        .reduce((old, cur, i) => {
          if (i === 0) {
            r[0].push(1)
            pos = 0
          } else {
            if (cur === old) {
              r[0][pos] += 1
              r[0].push(0)
            } else {
              r[0].push(1)
              pos = i
            }
          }
          return cur
        }, {})
      // pos = 0
      // this.tableData
      //   .map(e => {
      //     return e.module
      //   })
      //   .reduce((old, cur, i) => {
      //     if (i === 0) {
      //       r[1].push(1)
      //       pos = 0
      //     } else {
      //       if (cur === old) {
      //         r[1][pos] += 1
      //         r[1].push(0)
      //       } else {
      //         r[1].push(1)
      //         pos = i
      //       }
      //     }
      //     return cur
      //   }, {})
      return r
    },
    filters() {
      let obj = {}
      this.th.forEach(e => {
        obj[e.fieldname] = Array.from(
          new Set(
            this.tableData.map(row => {
              return row[e.fieldname] || ''
            })
          )
        ).map(val => {
          return { text: val || '', value: val || '' }
        })
      })
      return obj
    },
    tbDate() {
      return this.tableData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      )
    }
  },
  methods: {
    //表头筛选
    filterHandler(value, row, column) {
      //console.log(value, row, column, 'filterHandler')
      const property = column['columnKey']
      return row[property] === value
    },
    treeClickFun() {
      if (this.clickStatus) {
        this.clickStatus = false
        // this.$emit("treeClickFun",this.clickStatus)
      } else {
        this.clickStatus = true
        // this.$emit("treeClickFun",this.clickStatus)
      }
    },
    _Query_tsys_dicvalue() {
      Query_tsys_dicvalue({ mautoid: '1' }).then(res => {
        this.tboptions.phase = res.list.map(e => {
          return {
            value: e.dicvalue,
            label: e.dicvalue
          }
        })
      })
      Query_tsys_dicvalue({ mautoid: '2' }).then(res => {
        this.tboptions.module = res.list.map(e => {
          return {
            value: e.dicvalue,
            label: e.dicvalue
          }
        })
      })
      Query_tsys_dicvalue({ mautoid: '3' }).then(res => {
        this.tboptions.type = res.list.map(e => {
          return {
            value: e.dicvalue,
            label: e.dicvalue
          }
        })
      })
      Query_tsys_dicvalue({ mautoid: '4' }).then(res => {
        this.tboptions.zt = res.list.map(e => {
          return {
            value: e.dicvalue,
            label: e.dicvalue
          }
        })
      })
      Query_tsys_dicvalue({ mautoid: '5' }).then(res => {
        this.tboptions.name = res.list.map(e => {
          return {
            value: e.dicvalue,
            label: e.dicvalue
          }
        })
      })
    },
    _GetFZRlist() {
      GetFZRlist().then(res => {
        this.tboptions.fzr = res.list.map(e => {
          return {
            value: e.empname,
            label: e.empname
          }
        })
      })
    },
    _Query_tpr_xm_dy() {
      this.defalut = []
      // this.tboptions.name = []
      this.data = []
      this.ini = []
      this.tableData = []
      Query_tpr_xm_dy({ mautoid: this.$route.query.autoid }).then(res => {
        let p = [],
          n = [],
          m = [],
          data = []
        res.list.forEach(e => {
          e.phase = res.list[0].phase
          e.isEdit = true
          if (p.indexOf(e.phase) == -1) {
            p.push(e.phase)
            data.push({
              id: data.length,
              label: e.phase,
              ps: '15%',
              children: [
                {
                  label: e.name,
                  children: [e.module]
                }
              ]
            })
            n = [e.name]
            m = [e.module]
            // 默认打开全部
            this.defalut.push(data.length - 1 + '')
            this.defalut.push(data.length - 1 + '-' + (n.length - 1) + '')
          } else {
            if (n.indexOf(e.name) == -1) {
              n.push(e.name)
              m = [e.module]
              data[p.indexOf(e.phase)].children.push({
                label: e.name,
                children: [e.module]
              })
              // 默认打开全部
              this.defalut.push(data.length - 1 + '-' + (n.length - 1) + '')
            } else {
              // console.log(data, p, n, e)

              if (
                data[p.indexOf(e.phase)].children[
                  n.indexOf(e.name)
                ].children.indexOf(e.module) == -1
              ) {
                data[p.indexOf(e.phase)].children[
                  n.indexOf(e.name)
                ].children.push(e.module)
              }
            }
          }
          // if (n.indexOf(e.name) == -1) {
          //   n.push(e.name)
          // }
        })
        // this.tboptions.name = n.map(e => {
        //   return {
        //     value: e,
        //     label: e
        //   }
        // })
        // console.log(data, this.defalut, '1111111111111111')

        this.data = data
        this.ini = res.list
        // 获取当前显示的表格
        this.getTable()
      })
    },
    // 循环添加颜色的方法
    getColor(array) {
      let i = 0
      if (array.length > 0) {
        array.forEach((item, index) => {
          if (i == 12) {
            i = 0
          }
          item.ys = this.color[i]
          i++
        })
      }
      return array
    },
    tableSave(isadd, excel) {
      const data =
        isadd == '1'
          ? excel
          : this.tableData
              .slice(
                (this.currentPage - 1) * this.pageSize,
                this.currentPage * this.pageSize
              )
              .filter(e => {
                return !(e.ischeck1 || e.ischeck2)
              })
      BirthEdit_tpr_xm_dy({
        data,
        isadd: isadd,
        crman: this.userInfo.name
      })
        .then(res => {
          if (res.error == '0') {
            this.$message.success('操作成功')
          } else {
            this.$message.error(res.errorinfo)
          }
        })
        .finally(res => {
          this._Query_tpr_xm_dy()
        })
    },
    headerClick() {
      this.tableData.forEach(e => {
        e.isEdit = false
      })
    },
    cellClick(row, column, cell, event) {
      this.tableData.forEach(e => {
        e.isEdit = false
      })
      // 已审核的记录无法修改
      row.isEdit = !(row.ischeck1 || row.ischeck2)
    },
    // enter-left
    cellMouseEneter(row, column, cell, event) {
      if (['模块分类', '所属模块'].indexOf(column.label) == -1) {
        this.$nextTick(() => {
          const { offsetHeight, offsetTop } = cell
          const _p = this.$refs.tool.parentElement // 父级元素['hidden-columns']
          if (this.toolShow === false) this.toolShow = true
          // 计算 需要固定列的总宽度
          const tst =
            cell.parentElement.parentElement.parentElement.parentElement
              .scrollTop
          // 公式 = 100% - 默认固定列[多选+序号] - 额外 - 固定列框宽
          // _p.style.maxWidth = `calc(100% - 110px - 20px - ${fw}px)`;
          _p.style.maxWidth = `calc(100% - 110px - 20px )`
          _p.style.height = offsetHeight + 'px'
          let header = document.getElementsByTagName('thead')
          _p.style.top = offsetTop + header[0].offsetHeight - tst + 'px'
          // console.log(this.toolShow,_p.style.top, 'this.toolShow')

          this.tablerow = row
        })
      } else {
        this.toolShow = false
      }
    },
    // leave
    toolsHideFn() {
      this.toolShow = false
      this.toolExpend = true
    },
    // 工具栏 鼠标移入事件
    toolsMouseEnter() {
      this.toolShow = true
      this.toolExpend = true
    },
    //双击行事件
    handRowdbClick(row, column, event) {
      this.actionClick({ actionName: 'editdetial' }, row)
    },
    // 审核事件
    actionClick(item, row) {
      console.log(item, row)
      switch (item.actionName) {
        case 'del':
          if (row.ischeck1 || row.ischeck2) {
            this.$message.warning('记录已审核，无法删除')
          } else {
            // 删除
            this.$confirm(
              '请保存其他记录后再进行删除，您确定更要删除该记录吗？',
              '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }
            ).then(() => {
              row.isEdit = false
              Edit_tpr_xm_dy({
                autoid: row.autoid,
                isactive: 0,
                isadd: false
              }).then(res => {
                this.$message.success('删除成功')
                this._Query_tpr_xm_dy() // 获取列表
              })
            })
          }
          break
        case 'editdetial':
          this.form = row
          this.title = '修改项目调研'
          this.showre = true
          this.$nextTick(() => {
            this.$refs.researchForm.form = JSON.parse(JSON.stringify(row))
          })
          break
        case 'edit':
          if (row.ischeck1 || row.ischeck2) {
            this.$message.warning('记录已审核，无法修改')
          } else {
            this.form = JSON.parse(JSON.stringify(row))
            this.title = '调整分类'
            this.showre = true
          }
          break
        case 'file':
          this.tablerow = row
          this.$refs.filelist.show = true
          break
        default:
          check_tpr_xm_dy({
            autoid: row.autoid,
            field: item.checkfield,
            value: !item.checkvalue,
            checkman: this.userInfo.name
          })
            .then(res => {
              if (res.error == '0') {
                this.$message.success('操作成功')
                row[item.checkfield] = !item.checkvalue
              } else {
                this.$message.error(res.errorinfo)
              }
            })
            .finally(res => {
              this._Query_tpr_xm_dy()
            })

          break
      }
    },
    labelHead: function(h, { column, $index }) {
      let l = column.label.length
      let f = 12
      column.minWidth = f * (l + 2) //加上一个文字长度
      return h('div', { class: 'table-head', style: { width: '100%' } }, [
        column.label
      ])
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },

    // 表格 操作方法
    tableOperate(index, row, type) {
      // this.curRow = row // 用currentChange 会导致打开 UserList 时 curRow还是空值，所以同意改成同一个方法赋值 this.curRow
      console.log('tableOperate', { index, row, type })
      // 编辑
      if (type == 'edit') {
        if (row.ischeck1 || row.ischeck2) {
          this.$message.warning('记录已审核，无法修改')
        } else {
          row.isEdit = true
          this.$forceUpdate()
        }
      } else if (type == 'cancel') {
        row.isEdit = false
        // 还原数据: 刷选上次接口返回的数据
        this.ini.forEach(el => {
          if (row.autoid == el.autoid) {
            let obj = JSON.parse(JSON.stringify(el))
            Object.assign(row, obj)
            this.$forceUpdate()
          }
        })
      } else if (type == 'save') {
        // 修改
        row.isactive = 1
        row.isadd = false
        Edit_tpr_xm_dy(row).then(res => {
          this.$message.success('修改成功')
          row.isEdit = false
          this._Query_tpr_xm_dy() // 获取列表
        })
      } else if (type === 'delete') {
        if (row.ischeck1 || row.ischeck2) {
          this.$message.warning('记录已审核，无法删除')
        } else {
          // 删除
          this.$confirm('您确定更要删除该记录吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            row.isEdit = false
            Edit_tpr_xm_dy({
              autoid: row.autoid,
              isactive: 0,
              isadd: false
            }).then(res => {
              this.$message.success('删除成功')
              this._Query_tpr_xm_dy() // 获取列表
            })
          })
        }
      }
    },
    copy() {
      if (this.tableData.length == 0) {
        this.$message.warning('当前没有记录')
        return
      }
      let arr = this.tableData.filter(e => {
        //生产任务明细时：必须勾上了 是否调研的才能生成

        return !e.sc && e.dy
      })
      if (arr.length == 0) {
        this.$message.warning('当前没有可生成的记录')
        return
      }
      this.$confirm(
        '您确定更要生成当前的任务明细吗？每个调研任务只能生成一次',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        Copy_tpr_xm_dy({
          autoidlist: arr
            .map(e => {
              return e.autoid
            })
            .join(',')
        }).then(res => {
          this.$message.success('生成成功')
          this._Query_tpr_xm_dy() // 获取列表
        })
      })
    },
    // 导入通用任务
    copyty() {
      Copy_tpr_xm_dy_ty({
        autoid: this.$route.query.autoid,
        crman: this.userInfo.name
      }).then(res => {
        this.$message.success('导入成功')
        this._Query_tpr_xm_dy() // 获取列表
      })
    },
    // 高亮行
    handleCurrentRow(val) {
      this.tablerow = val
    },
    handleSelectionChange(val) {
      this.tableChange = val
    },
    // 点击form左边列表
    handClickProList(e) {
      this.prolistchoos = e
      this.$refs.form.form = e
    },
    add() {
      this.title = '新增项目调研'
      this.showre = true
      this.form.autoid = 0
      this.form.phase = ''
      this.form.name = ''
      this.form.module = ''
      // 获取当前选中的行，序号+1
      let sqnum = ''
      if (this.tablerow) {
        sqnum = this.tablerow.sqnum.toString()
        if (sqnum.indexOf('.') > -1) {
          let arr = sqnum.split('.')
          try {
            arr[arr.length - 1] = Number(arr[arr.length - 1]) + 1
            sqnum = arr.join('.')
          } catch {}
        } else {
          try {
            sqnum = Number(sqnum) + 1
          } catch {}
        }
      }
      this.$nextTick(() => {
        this.$refs.researchForm.form = {
          mautoid: this.$route.query.autoid,
          crman: this.userInfo.name,
          autoid: 0,
          module: '',
          type: '',
          taskdetail: '',
          instructions: '',
          fzr: '',
          dy: false,
          sqnum: sqnum
        }
      })
    },
    // 项目调研
    closeDialogre(a) {
      if (a == 'confirm') {
        // 保存
        let form =
          this.title == '新增项目调研' || '修改项目调研'
            ? this.$refs.researchForm.form
            : this.form
        form.isactive = 1
        if (this.title == '新增项目调研' || '修改项目调研') {
          form.phase = this.form.phase
          form.name = this.form.name
        }
        form.isadd = this.title == '新增项目调研'
        form.mautoid = this.$route.query.autoid
        Edit_tpr_xm_dy(form)
          .then(res => {
            if (res.error == '0') {
              this.$message.success('保存成功')
              this.showre = false
            } else {
              this.$message.error(res.errorinfo)
            }
          })
          .finally(res => {
            this._Query_tpr_xm_dy()
          })
      } else {
        this.showre = false
      }
    },
    formSave() {
      let form = this.$refs.form.form
      form.isactive = 1
      form.isadd = false
      Edit_tpr_xm_dy(form)
        .then(res => {
          if (res.error == '0') {
            this.$message.success('保存成功')
          } else {
            this.$message.error(res.errorinfo)
          }
        })
        .finally(res => {
          this._Query_tpr_xm_dy()
        })
    },
    // 添加变更记录
    addBG() {
      this.title = '新增项目变更'
      this.show = true
      this.fileList = []
      this.$nextTick(() => {
        this.$refs.researchCHForm.form = {
          mautoid: this.$route.query.autoid,
          crman: this.userInfo.name,
          autoid: 0,
          module: '',
          type: '',
          taskdetail: '',
          contant: '',
          instructions: '',
          fzr: '',
          week: 0,
          bd: null,
          ed: null
        }
      })
    },

    // 变更记录
    closeDialog(a) {
      if (a == 'confirm') {
        // 保存
        let form = this.$refs.researchCHForm.form
        form.isactive = 1
        form.isadd = this.title == '新增项目变更'
        Edit_tpr_xm_dy_change(form).then(res => {
          if (res.error == '0') {
            this.$message.success('保存成功')
            const autoid = res.autoid
            // 上传附件
            this.afterManualUpload(this.fileList, '项目调研变更', false, autoid)
            this.show = false
          } else {
            this.$message.error(res.errorinfo)
          }
        })
      } else {
        this.show = false
      }
    },
    // 手动上传弹窗回调事件
    async afterManualUpload(fileList, pctype, keepOriginalName, autoid) {
      // keepOriginalName // 保留原文件名
      let errorData = []
      let hasImp = 0
      let fuckLength = fileList.length

      if (fileList.length > 0) {
        for (const file of fileList) {
          // 保留文件名
          let obj = {
            autoid: autoid,
            username: this.userInfo.name,
            cusfilename: createGguid(),
            packagetype: pctype,
            file: file.raw,
            ty: '0'
          }
          if (keepOriginalName) {
            obj.cusfilename = file.name.substring(0, file.name.lastIndexOf('.'))
          }
          await upLoadCustomFile(obj).then(res => {
            if (res == 'OK') {
            } else {
              errorData.push({ res: file.name + '_' + res })
            }
            hasImp = hasImp + 1
            if (hasImp == fuckLength) {
              if (errorData.length == 0) {
                this.$message.success('导入成功')
              }
            }
          })
        }
      }
    },
    showTable() {
      this.$refs.dybgTable.show = true
    },
    setchoosName(e) {
      this.choosName = e
      // 获取当前显示的表格
      this.getTable()
    },
    getTable() {
      let ddd = this.ini.filter(e => {
        if (this.input) {
          return (
            this.choosName.phase == null ||
            (e.phase == this.choosName.phase &&
              (e.name == this.choosName.name || this.choosName.name == null) &&
              (e.module == this.choosName.module ||
                this.choosName.module == null) &&
              (e.module.indexOf(this.input) > -1 ||
                e.taskdetail.indexOf(this.input) > -1 ||
                e.type.indexOf(this.input) > -1 ||
                e.instructions.indexOf(this.input) > -1 ||
                e.fzr.indexOf(this.input) > -1))
          )
        } else {
          return (
            this.choosName.phase == null ||
            (e.phase == this.choosName.phase &&
              (e.name == this.choosName.name || this.choosName.name == null) &&
              (e.module == this.choosName.module ||
                this.choosName.module == null))
          )
        }
      })

      this.tableData = JSON.parse(JSON.stringify(ddd))
    },
    //监控上传文件列表
    handleChange(file, fileList) {
      let existFile = fileList
        .slice(0, fileList.length - 1)
        .find(f => f.name === file.name)
      if (existFile) {
        this.$message.error('当前文件已经存在!')
        fileList.pop()
      }
      this.fileList = fileList
    },
    // 移除
    handleRemove(file, fileList) {
      this.fileList = fileList
      //  console.log(fileList,'执行了')
    },
    // 移除前方法
    removeBefore(file, fileList) {
      return this.$confirm(`${'确定移除'} ${file.name}？`)
    },
    // 合并行方法
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        columnIndex === 0
        // || columnIndex === 1
      ) {
        // console.log(this.spanArr, columnIndex, rowIndex)

        const _row = this.spanArr[columnIndex][rowIndex]
        const _col = _row > 0 ? 1 : 0
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },
    // 打开excel导入弹窗
    Excel() {
      this.$refs.TableImport.show = true
    },
    // 下载excel模板
    downloadd() {
      var a = document.createElement('a') // 创建一个<a></a>标签
      a.href = '/通用调研模板.xlsx' //重点（如测试发现下载文件不存在/找不到，检查路径）
      a.download = '通用调研模板.xlsx' // 设置下载文件文件名
      a.style.display = 'none' // 隐藏a标签
      document.body.appendChild(a) // 将a标签追加到文档对象中
      a.click() // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
      a.remove()
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.el-container.research {
  background: #fff;
  border-radius: 10px;
  height: 100%;
  .el-aside {
    height: 100%;
    border-right: 1px solid #e5e5e5;
    .head {
      height: 80px;
      border-bottom: 1px solid #e5e5e5;
      display: flex;
      align-items: center;
      font-size: 25px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      padding: 0 10px;
      i {
        color: #fff;
        background: rgba(0, 127, 245, 1);
        border-radius: 50%;
        padding: 5px;
        font-size: 12px;
        margin-right: 10px;
      }
    }
    .el-menu {
      height: calc(100% - 130px);
      overflow-y: auto;
      /deep/ .el-menu-item-group__title {
        display: none;
      }
      /deep/ .el-submenu__title,
      .el-menu-item {
        height: 30px;
        line-height: 30px;
      }
      /deep/ .or {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        font-size: 18px;
        padding-right: 15px;
        .ico1 {
          color: #333;
        }
        .ico2 {
          color: rgba(0, 127, 245, 1);
        }
        .ps {
          font-size: 14px;
          font-weight: normal;
          color: #999;
        }
      }
    }
    .el-menu.ty {
      height: calc(100% - 90px);
    }
    .footer {
      padding: 0 10px;
      .bg {
        width: 170px;
      }
    }
  }
  .toggle-middle-col {
    background: #fff;
    .tree-toggle {
      display: flex;
      top: 0;
      bottom: 0;
      left: 0;
      width: 15px;
      background: rgb(232, 237, 247);
      height: 100%;
      align-items: center;
      position: relative;
      .toggle-icon {
        display: inline-flex;
        width: 100%;
        height: 30px;
        cursor: pointer;
        // border-radius: 2px 0 0 2px;
        align-items: center;
        position: absolute;
        background: #4e89f8;
        color: #fff;
      }
    }
  }
  .el-main {
    .toolbar {
      display: flex;
      justify-content: space-between;
      .tl {
        .i150 {
          width: 150px;
          margin: 5px;
        }
      }
      .tr {
        span {
          margin: 0 5px;
          cursor: pointer;
        }
        .isactive {
          color: rgba(0, 127, 245, 1);
        }
      }
    }
    .tablemode {
      height: calc(100vh - 340px);
      .footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
      }
      .el-table {
        // 工具栏
        /deep/ .hidden-columns {
          visibility: inherit;
          z-index: 9999;
          right: 7px;
          // margin-top: 3px;
          .my_tools {
            height: 100%;
            min-width: 45px;
            max-width: 100%;
            // padding: 0 0 0 20px;
            padding: 0 25px 0 20px;
            background: linear-gradient(
              to right,
              rgba(0, 0, 0, 0) 0%,
              #eee 30px,
              #ccc 100%
            );
            position: relative;
            .tools_box {
              @include wh(100%, 100%);
              display: flex;
              align-items: center;
              overflow: auto;
              .el-button {
                // 工具栏 内容字体大小随表单（后台控制）PS：目前只用到button，后期有需要其他再另行补充
                // @include _font;
                width: 100%;
                height: 100%;
                font-size: 12px;
                // display: flex;
                // flex-direction: column;
                // align-items: center;
                svg {
                  display: block;
                  margin: 2px auto;
                }
              }
            }
            // 隐藏按钮
            .hide_btn {
              position: absolute;
              top: 0;
              right: 0;
              @include wh(20px, 100%);
              @include flexCenter;
              border-left: 1px solid transparent;
              transition: all 0.2s;
              &:hover {
                // background: #ccc;
                background: #aaa;
                cursor: pointer;
                // border-left-color: #FFF;
                color: #fff;
              }
            }
          }
          .hide {
            transition: all 0.3s;
            svg {
              transform: rotate(180deg);
            }
          }
        }
        /deep/tbody {
          .el-table__cell {
            padding: 0;

            .cell {
              white-space: pre-wrap;
              padding: 10px 0;
            }
          }
        }
        .table_operate {
          margin: 0 5px;
        }
        /deep/.el-table__fixed,
        /deep/.el-table__fixed-right {
          height: calc(100% - 18px) !important;
        }
      }
    }
    .tablemode.ty {
      height: calc(100vh - 200px);
    }
    .el-container.formmode {
      height: calc(100vh - 290px);
      .el-aside {
        height: 100%;
        background: #eee;
        padding: 10px 0;
        .prolist {
          padding: 0 10px;
          font-size: 18px;
          height: 30px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .ico {
            display: inline-block;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background: #1890ff;
            margin-right: 5px;
            visibility: hidden;
          }
        }
        .prolist.isactive {
          background: lightblue;
          color: #1890ff;
          .ico {
            visibility: visible;
          }
        }
      }
      .el-main {
        height: 100%;
        overflow-y: auto;
        .formhead {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px;
          .title {
            color: #000;
            font-size: 20px;
            font-weight: bold;
            span {
              font-size: 25px;
            }
          }
        }
        .form {
          // background: #000;
          overflow-y: auto;
          height: calc(100% - 110px);
        }
        .foot {
          display: flex;
          justify-content: end;
        }
      }
    }
  }
}
.reCHForm,
.reForm {
  /deep/ .el-dialog__body {
    padding: 10px;
  }
}
/deep/ .el-form-item {
  .el-form-item__label {
    font-weight: bold;
  }
}
</style>
